import { render, staticRenderFns } from "./index.vue?vue&type=template&id=118f904d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=118f904d&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=118f904d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118f904d",
  null
  
)

export default component.exports